module.exports = __webpack_public_path__ + "img/auth-banner.804c3373.webp";